<template>
    <el-container style="height: calc(100vh - 80px)" class="bg-white">
        <el-header style="padding: 0px; height: auto; ">
            <!-- title部 -->
            <div class="h-12 p-4 shadow-md">システム設定 > 作業員管理</div>

            <!-- 検索部 -->
            <div class="p-5">
                <div class="border border-gray-300 rounded-md p-4">
                    <el-form :model="searchForm" label-width="auto">
                        <div class="flex flex-col md:flex-row gap-x-4">
                            <el-form-item label="作業員名" class="md:w-80">
                                <el-input v-model="searchForm.operator_name" placeholder="作業員名(前方一致)" clearable />
                            </el-form-item>

                            <el-button class="w-24" type="primary" @click="handleSearchButton">検索</el-button>
                        </div>
                    </el-form>

                    <!-- <div class="flex justify-end">
                        <el-button class="w-48" type="primary"
                            @click="handleAddButton">新規（削除予定）</el-button>
                    </div> -->
                </div>
            </div>
        </el-header>

        <!-- 主显示部 -->
        <el-main style="padding-block: 0px;" v-loading="loading">
            <!-- テーブル -->
            <div class="border border-gray-300 rounded-md p-4">
                <el-table :data="mTableData" :height="'calc(100vh - 350px)'">
                    <!-- <el-table-column label="編集（削除予定）" width="160" align="center">
                        <template #default="scope">
                            <el-button type="primary" link @click="handleEditButton(scope.row)">
                                <el-icon>
                                    <Edit />
                                </el-icon>
                                （削除予定）
                            </el-button>
                        </template>
</el-table-column> -->
                    <el-table-column prop="operator_code" label="作業員コード" width="320" />
                    <el-table-column prop="operator_name" label="作業員名" min-width="200" />
                    <el-table-column prop="organization_name" label="所属会社" min-width="280" />
                    <el-table-column prop="telephone" label="電話番号" width="160" />
                    <el-table-column prop="app_version" label="アプリバージョン" width="140" />
                    <el-table-column label="削除" width="60" align="center">
                        <template #default="scope">
                            <el-button type="danger" link @click="handleDeleteButton(scope.row)">
                                <el-icon>
                                    <Delete />
                                </el-icon>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- ページネーション -->
            <div class="flex justify-end mt-2">
                <el-pagination v-model:current-page="mCurrentPage" v-model:page-size="mPageSize"
                    :page-sizes="[10, 20, 50]" layout="total, sizes, prev, pager, next, jumper" :total="mTotalRecords"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </el-main>

        <el-footer style="height: 20px;"> </el-footer>
    </el-container>

    <!-- 新規登録・編集ダイアログ -->
    <!-- <el-dialog v-model="dialogFormVisible" :title="form.add_update === 'add' ? '作業員新規登録' : '作業員編集'" width="600px" align-center>
        <el-form :model="form" :rules="rules" ref="formRef" label-width="auto">

            <el-form-item label="作業員コード" prop="operator_code">
                <el-input v-model="form.operator_code" :disabled="form.add_update === 'update'"
                    placeholder="作業員コードを入力" />
            </el-form-item>

            <el-form-item label="作業員名" prop="operator_name">
                <el-input v-model="form.operator_name" placeholder="作業員名を入力" />
            </el-form-item>

            <el-form-item label="所属会社" prop="organization_name">
                <el-input v-model="form.organization_name" placeholder="会社名を入力" />
            </el-form-item>

            <el-form-item label="電話番号" prop="telephone">
                <el-input v-model="form.telephone" placeholder="電話番号を入力" />
            </el-form-item>

            <el-form-item label="アプリバージョン" prop="app_version">
                <el-input v-model="form.app_version" placeholder="アプリバージョンを入力" />
            </el-form-item>

        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">キャンセル</el-button>
                <el-button type="primary" @click="handleAddUpdateSubmit(formRef)">確認</el-button>
            </div>
        </template>
    </el-dialog> -->
</template>

<script lang="ts">
import axios, { AxiosResponse } from 'axios';
import { ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn } from 'element-plus';
import { defineComponent, onMounted, ref } from 'vue';
import type { FormInstance, FormRules } from 'element-plus';
import { Delete, /*Edit*/ } from '@element-plus/icons-vue';
import { ErrorCode, ResponseData, ResponseStatus } from '@/components/common/response';
import { getErrorMessage } from '@/components/common/errorMessage';
// import { Operation} from '@/components/common/request';
import { OperatorInfo } from '@/components/models/operatorinfo';

export default defineComponent({
    name: 'MntOperator',
    components: {
        ElTable,
        ElTableColumn,
        ElPagination,
        Delete,
        // Plus,
        // Edit,
        // Search,
    },
    setup() {

        const searchForm = ref<any>({
            operator_name: '',
        });

        // const form = ref<OperatorInfo>({
        //     add_update: Operation.unknow,
        //     operator_code: '',
        //     operator_name: '',
        //     organization_name: '',
        //     telephone: '',
        //     phone_os_version: '',
        //     app_version: '',
        //     calera_formware_version: '',
        //     hrm_formware_version: '',
        // });

        const loading = ref<boolean>(true);
        const mTableData = ref<OperatorInfo[]>([]);
        const mTotalPages = ref<number>(0);
        const mTotalRecords = ref<number>(0);
        const mCurrentPage = ref<number>(1);
        const mPageSize = ref<number>(10);

        const dialogFormVisible = ref<boolean>(false);

        const formRef = ref<FormInstance>()
        const rules = ref<FormRules>({
            operator_code: [
                { required: true, message: '作業員コードを入力してください', trigger: 'blur' },
                { min: 1, max: 15, message: '作業員コードは1〜15文字の間で入力してください', trigger: 'blur' },
                { pattern: /^[A-Za-z0-9]+$/, message: '作業員コードは半角英数字で入力してください', trigger: 'blur' }
            ],
            operator_name: [
                { required: true, message: '作業員名を入力してください', trigger: 'blur' },
                { min: 2, max: 25, message: '作業員名は2〜25文字の間で入力してください', trigger: 'blur' },
                { pattern: /^[^<>\\/|&;$#%@"'{}()[\]]+$/, message: '作業員名に禁止使用字符が含まれています', trigger: 'blur' }
            ],
            organization_name: [
                { required: true, message: '所属会社を入力してください', trigger: 'blur' },
                { min: 2, max: 25, message: '所属会社は2〜25文字の間で入力してください', trigger: 'blur' },
                { pattern: /^[^<>\\/|&;$#%@"'{}()[\]]+$/, message: '所属会社に禁止使用字符が含まれています', trigger: 'blur' }
            ],
            telephone: [
                { min: 10, max: 13, message: '電話番号は10〜13文字の間で入力してください', trigger: 'blur' }
            ]

        })

        /***** マウント **************************/
        onMounted(() => {
            getOperatorList();
        });

        /***** ボタン **************************/
        const handleSearchButton = () => {
            getOperatorList();
        };

        // const handleAddButton = () => {
        //     dialogFormVisible.value = true;
        //     nextTick(() => {
        //         formRef.value?.resetFields();
        //         form.value = {
        //             add_update: Operation.add,
        //             operator_code: '',
        //             operator_name: '',
        //             organization_name: '',
        //             telephone: '',
        //             phone_os_version: '',
        //             app_version: '',
        //             calera_formware_version: '',
        //             hrm_formware_version: '',
        //         };
        //     });
        // };

        // const handleEditButton = (row: OperatorInfo) => {
        //     dialogFormVisible.value = true;
        //     nextTick(() => {
        //         formRef.value?.resetFields();
        //         form.value = {
        //             add_update: Operation.update,
        //             operator_code: row.operator_code,
        //             operator_name: row.operator_name,
        //             organization_name: row.organization_name,
        //             telephone: row.telephone,
        //             phone_os_version: row.phone_os_version,
        //             app_version: row.app_version,
        //             calera_formware_version: row.calera_formware_version,
        //             hrm_formware_version: row.hrm_formware_version,
        //         };
        //     });
        // };

        const handleDeleteButton = (row: OperatorInfo) => {
            ElMessageBox.confirm('削除しますか？', '削除', {
                confirmButtonText: '削除',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                deleteOperator(row);
            }).catch(() => {
                // 取消删除
            });
        };

        // const handleAddUpdateSubmit = async (formEl: FormInstance | undefined) => {
        //     if (!formEl) return
        //     await formEl.validate((valid) => {
        //         if (valid) {
        //             if (form.value.add_update === Operation.add) {
        //                 addOperator();
        //             } else if (form.value.add_update === Operation.update) {
        //                 updateOperator(form.value);
        //             }
        //             dialogFormVisible.value = false;
        //         }
        //     })
        // }

        const handleSizeChange = (size: number) => {
            mPageSize.value = size;
            getOperatorList();
        };
        const handleCurrentChange = (page: number) => {
            mCurrentPage.value = page;
            getOperatorList();
        };

        const apiCall = async (method: 'get' | 'post' | 'put' | 'delete', url: string, data?: any) => {
            try {
                loading.value = true;
                const res: AxiosResponse<ResponseData<any>> = await axios({
                    method,
                    url,
                    data,
                    params: method === 'get' ? data : undefined, // Use params only for GET requests
                });

                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    if (method !== 'get') {
                        ElMessage.success(res.data.message); // Show success message for non-GET requests
                    }
                    return res.data;
                } else {
                    ElMessage.error(res.data.message);
                    return null;
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(error as Error));
                return null;
            } finally {
                loading.value = false;
            }
        };

        /***** DB 操作 **************************/
        const getOperatorList = async () => {
            const data = await apiCall('get', '/api/operators2', {
                page: mCurrentPage.value,
                limit: mPageSize.value,
                operator_name: searchForm.value.operator_name,
            });
            if (data) {
                const { total, totalPages, currentPage, data: operatorData } = data;
                mCurrentPage.value = currentPage!;
                mTotalPages.value = totalPages!;
                mTotalRecords.value = total!;
                // mTableData.value = operatorData!;
                mTableData.value = operatorData.map((item: any) => ({
                    is_active: item.is_active,
                    id: item.id,
                    operator_code: item.operator_code || '',
                    operator_name: item.operator_name || '',
                    organization_name: item.organization_name || '',
                    telephone: item.telephone || '',
                    app_version: item.app_version || '',
                }));
            }
        };

        // const addOperator = async () => {
        //     await apiCall('post', '/api/operators', form.value);
        //     getOperatorList();
        // };

        // const updateOperator = async (row: OperatorInfo) => {
        //     await apiCall('put', `/api/operators/${row.operator_code}`, row);
        //     getOperatorList();
        // };

        const deleteOperator = async (row: OperatorInfo) => {
            await apiCall('delete', `/api/operators2/${row.id}`);
            getOperatorList();
        };

        return {
            searchForm,
            // form,
            dialogFormVisible,
            loading,
            mTableData,
            mCurrentPage,
            mPageSize,
            mTotalPages,
            mTotalRecords,
            handleSearchButton,
            // handleAddButton,
            // handleEditButton,
            handleDeleteButton,
            handleSizeChange,
            handleCurrentChange,
            // handleAddUpdateSubmit,
            formRef,
            rules,
        }
    }
});
</script>